import { createFileRoute } from "@tanstack/react-router";
import Navigation from "@/features/navigation";
import { UnsubscribeFailure } from "@/features/unsubscribe";

const Route = createFileRoute("/_public/notifications/unsubscribe/failure/")({
  component: () => (
    <Navigation variant="reduced">
      <UnsubscribeFailure />
    </Navigation>
  ),
});

export { Route };
